import { Button, StaticField } from '@intech/web-ui';
import React from 'react';
import { FaCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import { ContratoEntidade } from '../../../entidades';
import { Icon } from './styles';

interface ItemProps {
  info: ContratoEntidade;
}

export interface IconProps {
  type: 'danger' | 'info' | 'warning' | 'success';
}

export const EmprestimoItem: React.FC<ItemProps> = ({
  info
}) => {
  const history = useHistory();

  const ref_cor: { [index: string]: IconProps["type"] } = {
    "1": "warning",
    "2": "warning",
    "3": "success",
    "5": "danger",
  };

  function AbrirDetalhe() {
    history.push(`emprestimoDetalhe/${info.NUM_CONTRATO}/${info.ANO_CONTRATO}`);
  }

  return (
    <tr>
      <td>
        <Icon type={ref_cor[info.CD_SITUACAO]}>
          <FaCircle />
        </Icon>
        {info.DS_SITUACAO}
      </td>
      <td>{`${info.NUM_CONTRATO}/${info.ANO_CONTRATO}`}</td>
      <td>{info.DT_SOLICITACAO}</td>
      <td>{info.DT_CREDITO}</td>
      <td>
        <StaticField
          value={info.VL_SOLICITADO ? info.VL_SOLICITADO : 0}
          type={"money"}
        />
      </td>
      <td>
        <StaticField
          value={info.VL_LIQUIDO ? info.VL_LIQUIDO : 0}
          type={"money"}
        />
      </td>
      <td>{info.PRAZO}</td>
      <td>
        <Button
          onClick={AbrirDetalhe}
          title={"Detalhar"}
          type={"primary"}
        />

      </td>
    </tr>
  );
}